// extracted by mini-css-extract-plugin
export var container = "_h1-1";
export var editor = "_h1-2";
export var resizable = "_h1-3";
export var wrapper = "_h1-0";